import { useMutation, useQueryClient } from 'react-query';
import { submitCommentService } from '../redux/services/postService';
import HookTypes from '../redux/types/hooks';

type Mutation = {
  owner: string;
  postBody: string;
  postId: string;
  responseToCommentId: string | null;
};

export default function mutation() {
  const queryClient = useQueryClient();

  return useMutation(
    async (mutation: Mutation) => {
      await submitCommentService(
        mutation.owner,
        mutation.postBody,
        mutation.postId,
        mutation.responseToCommentId
      );
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(HookTypes.activity);
        await queryClient.refetchQueries();
      },
    }
  );
}
